import axios from "axios";
import { getReasonPhrase } from "http-status-codes";
import { v4 as uuidv4 } from "uuid";
import { CustomError, isProblemDetail, ProblemDetailError } from "./error";
import { csrfToken } from "./utils";

const handleAxiosError = (error: unknown): ProblemDetailError | CustomError => {
  if (axios.isAxiosError(error) && error.response) {
    const problemDetail = error.response.data;
    if (isProblemDetail(problemDetail)) {
      const requestId = problemDetail.id || uuidv4();
      return new ProblemDetailError({ id: requestId, ...problemDetail });
    } else {
      const statusCode = error.response.status;
      const statusText =
        error.response.statusText || getReasonPhrase(statusCode);
      return new CustomError(statusText, error.message);
    }
  }
  return error instanceof Error
    ? new CustomError("Application Error", error.message)
    : new CustomError("Application Error", "An unexpected error occurred");
};

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-CSRF-Token": csrfToken(),
  },
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(handleAxiosError(error));
  },
);

export { axiosInstance };
